/* Bigsmall header search - mobile experience v2 (28 Sep 2026)
   1. Keeps --bs-search-vvh / --bs-search-vvt equal to the visible viewport (shrinks when the keyboard opens),
      so the results list is never hidden behind it.
   2. Focuses the field when search opens on a phone and sets the keyboard's action key to "search".
   3. Recent searches (last 5, stored on the device only) shown when the field is empty.
   4. Scrolls the results list back to the top whenever new results render. */
(function () {
  'use strict';

  if (window.__BigsmallSearchMobileDropdown) return;
  window.__BigsmallSearchMobileDropdown = true;

  var vv = window.visualViewport;
  var root = document.documentElement;
  var phone = window.matchMedia('(max-width: 749px)');
  var STORE_KEY = 'bsRecentSearches';
  var MAX_RECENT = 5;
  var queued = false;
  var CLOCK = "<svg viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round' aria-hidden='true'><circle cx='12' cy='12' r='9'/><path d='M12 7v5l3 2'/></svg>";

  function apply() {
    queued = false;
    root.style.setProperty('--bs-search-vvh', Math.round(vv ? vv.height : window.innerHeight) + 'px');
    root.style.setProperty('--bs-search-vvt', Math.round(vv ? vv.offsetTop : 0) + 'px');
  }

  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(apply);
  }

  function readRecent() {
    try {
      var list = JSON.parse(window.localStorage.getItem(STORE_KEY) || '[]');
      return Array.isArray(list) ? list.filter(function (t) { return typeof t === 'string' && t; }).slice(0, MAX_RECENT) : [];
    } catch (error) {
      return [];
    }
  }

  function saveRecent(list) {
    try {
      window.localStorage.setItem(STORE_KEY, JSON.stringify(list));
    } catch (error) {
      /* storage unavailable (private mode) - recent searches simply will not persist */
    }
  }

  function remember(term) {
    term = String(term || '').trim();
    if (term.length < 2) return;
    var list = readRecent().filter(function (t) { return t.toLowerCase() !== term.toLowerCase(); });
    list.unshift(term);
    saveRecent(list.slice(0, MAX_RECENT));
  }

  function renderRecent(scope) {
    var predictive = scope.querySelector('predictive-search');
    var quick = predictive && predictive.querySelector('.bigsmall-search-quick-links');
    if (!quick) return;

    var block = predictive.querySelector('.bs-recent');
    var items = readRecent();

    if (!items.length) {
      if (block) block.hidden = true;
      return;
    }

    if (!block) {
      block = document.createElement('div');
      block.className = 'bs-recent';
      quick.parentNode.insertBefore(block, quick);
    }

    block.hidden = false;
    block.textContent = '';

    var head = document.createElement('div');
    head.className = 'bs-recent__head';
    var label = document.createElement('p');
    label.className = 'bs-recent__label';
    label.textContent = 'Recent searches';
    var clear = document.createElement('button');
    clear.type = 'button';
    clear.className = 'bs-recent__clear';
    clear.textContent = 'Clear';
    head.appendChild(label);
    head.appendChild(clear);
    block.appendChild(head);

    items.forEach(function (term) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'bs-recent__item';
      button.setAttribute('data-term', term);
      button.innerHTML = CLOCK;
      var text = document.createElement('span');
      text.textContent = term;
      button.appendChild(text);
      block.appendChild(button);
    });
  }

  function watchResults(details) {
    var list = details.querySelector('.predictive-search--header');
    if (!list || list.dataset.bsScrollReset === 'true') return;
    list.dataset.bsScrollReset = 'true';
    new MutationObserver(function () { list.scrollTop = 0; }).observe(list, { childList: true });
  }

  apply();

  if (vv) {
    vv.addEventListener('resize', schedule, { passive: true });
    vv.addEventListener('scroll', schedule, { passive: true });
  }
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('orientationchange', schedule, { passive: true });

  /* details toggles do not bubble, so listen in the capture phase */
  document.addEventListener('toggle', function (event) {
    schedule();
    var details = event.target;
    if (!details || !details.matches || !details.matches('.header__search details')) return;
    if (!details.open || !phone.matches) return;

    var input = details.querySelector('input[type=search]');
    if (input) input.setAttribute('enterkeyhint', 'search');
    renderRecent(details);
    watchResults(details);

    window.setTimeout(function () {
      if (details.open && input) input.focus({ preventScroll: true });
    }, 120);
  }, true);

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var recent = target.closest('.bs-recent__item');
    if (recent) {
      var scope = recent.closest('.search-modal__content');
      var field = scope && scope.querySelector('input[type=search]');
      if (field) {
        field.value = recent.getAttribute('data-term') || '';
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.focus({ preventScroll: true });
      }
      return;
    }

    var clear = target.closest('.bs-recent__clear');
    if (clear) {
      saveRecent([]);
      var box = clear.closest('.search-modal__content');
      if (box) renderRecent(box);
      return;
    }

    var result = target.closest('.header__search .predictive-search a, .header__search .predictive-search__item--term');
    if (result) {
      var content = result.closest('.search-modal__content');
      var current = content && content.querySelector('input[type=search]');
      if (current) remember(current.value);
    }
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.closest || !form.closest('.header__search')) return;
    var field = form.querySelector('input[type=search]');
    if (field) remember(field.value);
  }, true);
})();
